// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28iAW","title":"styles_title__1FBP3"};